// widgets/AgingReport.jsx (uses /reports/aging)
import React, { useEffect, useState } from 'react';
import { api } from '../scripts/api';
import { Clock } from 'lucide-react';
import '../App.css';
import './Widgets.css';

export default function AgingReport() {
  const [aging, setAging] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAging = async () => {
      try {
        const { data } = await api.get('/reports/aging', {
          params: { table: 'all_inventory', limit: 10 },
        });
        setAging(data.rows || []);
      } catch (e) {
        setError(e?.response?.data?.error || 'Failed to load aging report');
      } finally {
        setLoading(false);
      }
    };
    fetchAging();
  }, []);

  if (loading) return <div className="widget-loading">Loading...</div>;
  if (error) return <div className="widget-error">{error}</div>;

  return (
    <div className="widget aging-report">
      <h3 className="widget-title">Inventory Aging</h3>
      <table className="aging-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Age (Days)</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {aging.map((item) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td><Clock size={14} /> {item.age_days || 'N/A'}</td>
              <td>{item.unit_status || 'Unknown'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}